import { buildEntitiesFromWorkflowPrompt } from '@/ai/prompts'
import { fetchJsonResponse, streamJsonResponses } from '@/ai/api'

export const generateEntitiesFromWorkflow = async ({
  workflow,
  svgGraph,
  svgLanes,
  cardTypes,
  stream = false,
  onChunkReceived,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }
  if (stream && typeof onChunkReceived !== 'function') {
    return null
  }

  const messages = buildEntitiesFromWorkflowPrompt({
    workflow,
    svgGraph,
    svgLanes,
    cardTypes,
    stream
  })

  try {
    if (stream) {
      return await streamJsonResponses({
        messages,
        aiVersion: workflow.aiVersion,
        onChunkReceived,
        signal: abortController?.signal
      })
    } else {
      const response = await fetchJsonResponse({
        messages,
        aiVersion: workflow.aiVersion,
        signal: abortController?.signal
      })

      return response || null
    }
  } catch (error) {
    return null
  }
}
